import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Droppable } from "react-beautiful-dnd";
import { useParams } from 'react-router-dom';
import { Col, Row, Card } from 'react-bootstrap';
import { isUUID } from '../../../helpers/common';
import ColumnCard from './ColumnCard';
import EgForm from '../Form/EGForm';
import { isToday, usePermission } from "../../../helpers/common";
import { EG_OPTION_TYPES, EQUIPMENT_TRUCK, EQUIPMENT_SELF_PROPELLED, EQUIPMENT_HANDLING, EQUIPMENT_SCALE, EQUIPMENT_REMOTECONTROL } from '../../../constants';
import EGInfo from '../Form/EGInfo';

const Column = (props) => {
  const { isRequestingEg, isValidateEg, egInfo, search, egId, isHaveEg, equipmentListById, draggableType } = props;
  const [showModal, setShowModal] = useState(false);
  const [showEGInfoModal, setShowEGInfoModal] = useState(false);
  const [refreshCount, setRefreshCount] = useState(0);
  const [isEGValid, setIsEgValid] = useState(true);
  const [isDropDisabled, setDropDisable] = useState(false);
  const [egDetails, setEGDetails] = useState({});
  const params = useParams();

  const { farmId } = params;

  useEffect(() => {
    if (draggableType && egInfo) {
      if (egInfo.modeTypeId === 2) {
        //in order to restrict vehicle and implement type for Operator equipment group
        if (draggableType === "vehicle" || draggableType === "implement") setDropDisable(true);
        else setDropDisable(false);
      } else {
        //in order to restrict implement type for truck and self propelled equipment group
        if (draggableType === "implement") {
          const isImplementDropDisable = egInfo.list && isUUID(egInfo.list[0]) && equipmentListById[egInfo.list[0]]
            ? [EQUIPMENT_TRUCK, EQUIPMENT_SELF_PROPELLED].indexOf(equipmentListById[egInfo.list[0]].equipment_type_id) >= 0 : false;

          if (isImplementDropDisable) setDropDisable(true);
          else setDropDisable(false);
        } else setDropDisable(false);
      }
    }
  }, [draggableType]);

  useEffect(() => {
    if (egInfo && egInfo.id) {
      let egDetail = {
        ...egDetails
      };

      egDetail[egInfo.id] = {
        farm_uuid: farmId,
        equipment_group_uuid: egInfo.id,
        name: egInfo.name,
        vehicle_equipment_uuid: egInfo && isUUID(egInfo.list[0]) ? egInfo.list[0] : null,
        implement_equipment_uuid: egInfo && isUUID(egInfo.list[1]) ? egInfo.list[1] : null,
        device_uuid: egInfo && isUUID(egInfo.list[2]) ? egInfo.list[2] : null,
        operator_uuid: egInfo && isUUID(egInfo.list[3]) ? egInfo.list[3] : null,
      }
      setEGDetails(egDetail);
    }
  }, [egInfo])

  useEffect(() => {
    if (isValidateEg) {
      let isEgValid = true;

      if (!(egInfo && egInfo.list)) isEgValid = true;
      else if (egInfo.modeTypeId === 1) {
        let implementId = egInfo && egInfo.list.length > 0 ? egInfo.list[1] : null;
        let filteredImplement = props.optionList && props.optionList.implement && props.optionList.implement.list && props.optionList.implement.list.length > 0 ?
          props.optionList.implement.list.filter(e => e.equipment_uuid === implementId) : [];
        const isEGHandling = filteredImplement.length > 0 ? filteredImplement[0].equipment_type_id === EQUIPMENT_HANDLING : false;
        const isEGScale = filteredImplement.length > 0 ? filteredImplement[0].equipment_type_id === EQUIPMENT_SCALE : false;
        const isEGRemoteCOntrol = filteredImplement.length > 0 ? filteredImplement[0].equipment_type_id === EQUIPMENT_REMOTECONTROL : false;

        isEgValid = (isEGHandling || isEGScale || isEGRemoteCOntrol) ? true : isUUID(egInfo.list[0]);     //to check vehicle is assigned or not
      }
      else isEgValid = isUUID(egInfo.list[3]);                                //to check whether operator is assigned or not

      setIsEgValid(isEgValid);
    }
    else setIsEgValid(true);
  }, [isValidateEg, egInfo])

  const handleClose = () => setShowModal(false);

  const handleShow = () => {
    setShowModal(true);
    setRefreshCount(refreshCount + 1)
  };

  const allow = usePermission();
  const isAllowEdit = allow("equipment-group", "edit") ? isToday(search.range) : false;
  const isAllowCreate = allow("equipment-group", "create") ? isToday(search.range) : false;

  return (
    <>
      <Card
        className={`h-100 column-container ${!isEGValid &&
          "not-valid"}`}
      >
        {isRequestingEg || (isHaveEg && !egInfo) ? (
          <Row>
            <Col className="text-center mt-3">Loading...</Col>
          </Row>
        ) : !isHaveEg ? (
          <div className="kanban-column-add">
            {isAllowCreate && (
              <span onClick={handleShow}>
                <i className="fa fa-plus-circle" />
                Add equipment group
              </span>
            )}
          </div>
        ) : (
          <>
            <Card.Header className="p-0 column-header">
              <Card.Title className="column-title">
                <Row>
                  <Col
                    xl={8}
                    lg={6}
                    sm={6}
                    md={6}
                    className={`name ${!isEGValid && "not-valid"}`}
                  >
                    <span title={egInfo.name}>{egInfo.name}</span>
                  </Col>
                  <Col xl={4} lg={6} sm={6} md={6}>
                    {
                      egDetails && egDetails[egInfo.id] &&
                      <span style={{ cursor: "pointer" }}>
                        <i
                          className="fa fa-clone mr-3 float-right"
                          title="copy"
                          onClick={() => setShowEGInfoModal(true)}
                        />
                      </span>
                    }
                    {isAllowEdit && (
                      <span>
                        <i
                          className="fa fa-pencil mr-3 float-right"
                          title="edit"
                          onClick={handleShow}
                        />
                      </span>
                    )}
                  </Col>
                </Row>
              </Card.Title>
            </Card.Header>
            <Card.Body className={`pb-2 overflow-auto p-1 column-body`}>
              <Droppable
                key={egInfo.id}
                isDropDisabled={isDropDisabled}
                disableInteractiveElementBlocking
                droppableId={egInfo.id}
              >
                {(provided, snapshot) => {
                  return (
                    <div
                      ref={provided.innerRef}
                      className={`${snapshot.isDraggingOver ? "dragging-over" : ""
                        } h-100`}
                    >
                      {EG_OPTION_TYPES.map((type, index) => {
                        const id = egInfo.list[index];
                        return (
                          isUUID(id) &&
                          !(
                            type === "vehicle" && egInfo.modeTypeId === 2
                          ) && (
                            <ColumnCard
                              key={index}
                              droppableId={egInfo.id}
                              id={id}
                              index={index}
                              type={type}
                            />
                          )
                        );
                      })}
                      {provided.placeholder}
                      {!isEGValid && (
                        <div className="toast-msg">
                          <p>
                            {egInfo.modeTypeId === 1
                              ? "Vehicle equipment is required.*"
                              : "Operator is required.*"}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                }}
              </Droppable>
            </Card.Body>
          </>
        )}
      </Card>
      <EgForm
        show={showModal}
        onHide={handleClose}
        egId={egId}
        isEditMode={isHaveEg}
        equipmentGroupInfo={egInfo}
        refreshCount={refreshCount}
      />
      {
        showEGInfoModal && egInfo && <EGInfo
          show={showEGInfoModal}
          onHide={() => setShowEGInfoModal(false)}
          egInfo={egInfo && egInfo.id ? egDetails[egInfo.id] : null}
        />
      }

    </>
  );
}

const mapStateToProps = (state, ownProps) => {
  const equipmentListById = {};
  state.egKanban.optionList.vehicle.list.forEach(item => equipmentListById[item.equipment_uuid] = item);
  return ({
    isValidateEg: state.egKanban.isValidateEg,
    isHaveEg: state.egKanban.kanban.hasOwnProperty([ownProps.egId]),
    isRequestingEg: state.egKanban.isRequestingEg,
    equipmentListById,
    egInfo: state.egKanban.kanban.hasOwnProperty([ownProps.egId]) ? state.egKanban.kanban[ownProps.egId] : null,
    optionList: state.egKanban.optionList,
    search: { range: state.analyze.searchParams.range }
  });
}

export default connect(mapStateToProps)(Column);